import { useState } from 'react'

import useAuthz from './useAuthz'

/**
 * Custom hook to manage analytics section and disposition state
 * Handles visibility based on route and admin status
 */
export function useDrawerState (location) {
  const { isAdmin } = useAuthz()
  const [dispositionExpanded, setDispositionExpanded] = useState(false)

  const shouldShowMetricsDrawer = location.pathname.includes('/campaign') ||
    (isAdmin && location.pathname === '/dashboard')

  const metricsDrawerOpen = location.pathname.includes('/campaign') ||
    location.pathname === '/dashboard'

  const handleDispositionToggle = (expanded) => {
    setDispositionExpanded(expanded)
  }

  return {
    dispositionExpanded,
    metricsDrawerOpen,
    shouldShowMetricsDrawer,
    handleDispositionToggle
  }
}

export default useDrawerState
